import PrefetchLink from "./PrefetchingLink";
import Content from "./parts/Content";
import Description from "./parts/Description";
import Gallery from "./parts/Gallery";
import InlineContent from "./parts/InlineContent";
import MinimumPrice from "./parts/MinimumPrice";
import Name from "./parts/Name";
import Price from "./parts/Price";
import Tags from "./parts/Tags";
import YarnWidget from "./parts/YarnWidget";
import styles from "./product-card.module.css";

const Card = ({ slug, name, children, ...props }: Props) => {
  return (
    <PrefetchLink
      href={`${slug}`}
      aria-label={name}
      data-product-card
      className={styles["product-card"]}
      {...props}
      prefetch={false}
    >
      <>{children}</>
    </PrefetchLink>
  );
};

const PC = {
  Card,
  Gallery: Gallery,
  Tags,
  Inline: InlineContent,
  YarnWidget,
  Content,
  Description,
  Price,
  MinimumPrice,
  Name
};

type Props = {
  slug: string;
  name: string;
  children: CompundProps;
} & Omit<
  React.HTMLAttributes<HTMLAnchorElement>,
  "href" | "aria-label" | "className"
>;

type Compounds =
  | typeof PC.Gallery
  | typeof PC.Content
  | typeof PC.Description
  | typeof PC.Tags
  | typeof PC.Inline
  | typeof PC.YarnWidget
  | typeof PC.Price
  | typeof PC.MinimumPrice
  | typeof PC.Name;

type CompundProps =
  | React.ReactComponentElement<Compounds>
  | React.ReactComponentElement<Compounds>[]
  | string;

export interface ProductCard__Image {
  url: string;
  alt: string;
}

export default PC;
